import { UserInfo } from '../models/userInfo';

export class UserInfoService {
    private _userInfo: UserInfo;
    private _isUserInfoLoaded = false;
    
    static $inject = ['$http', '$q', '$rootScope'];
    
    static stuInfo: UserInfo;
    constructor(private $http: ng.IHttpService,
        private $q: ng.IQService,
        private $rootScope: ng.IRootScopeService
        ) {
        
        }

    isUserInfoPopulated(): boolean {
        return this._isUserInfoLoaded;
    }
    
    loadUserInfo(): ng.IPromise<UserInfo> {
       
        const deferred = this.$q.defer<UserInfo>();
        this.$http.get('/getUserInfo')
            .then((response: ng.IHttpPromiseCallbackArg<UserInfo>) => {
                this._userInfo = response.data;
                this._isUserInfoLoaded = true;
                UserInfoService.stuInfo = response.data;
                deferred.resolve(this._userInfo);

            })
            .catch(
                (response: ng.IHttpPromiseCallbackArg<UserInfo>) => {
                    deferred.reject(response);
                });

        return deferred.promise;
    }

    getUserInfo(): UserInfo {
        
        return this._userInfo;
    }

  

    getUserRole(): angular.IPromise<string> {
        const deferred = this.$q.defer<string>();
        
        deferred.resolve(this._userInfo.role);
        return deferred.promise;
    }

    private extractError(result) {
        return (result.data && result.data.errors && result.data.errors.length > 0) ? result.data.errors[0] : 'Unexpected error occurred';
    }
}
angular.module('deliveryCreate.app')
    .service('UserInfoService', UserInfoService);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/userInfo/services/UserInfoService.ts
 **/